import PropTypes from 'prop-types';
import ReviewSection from '/components/ReviewSection';
import VisualDetails from '/components/VisualDetails';

const Footer = ({ activeProductType, parentProductId }) => {
	return (
		<div className="mt-6 md:mt-8">
			<VisualDetails productType={activeProductType} />
			<ReviewSection productId={parentProductId} />
		</div>
	);
};

Footer.propTypes = {
	activeProductType: PropTypes.string,
	parentProductId: PropTypes.string,
};

export default Footer;
